import '../plugins/MobileNavPlugin.js';
import '../plugins/ResponsiveHelper.js';

var mobileNavFiltersInitialized = false;

// mobile menu init
export default function initMobileNavFilters() {
  if (mobileNavFiltersInitialized) {
    return;
  }

  mobileNavFiltersInitialized = true;

  jQuery('body').mobileNav({
    menuActiveClass: 'filters-active',
    menuOpener: '.filters-main-opener',
    menuDrop: '.filters-content-drop',
    hideOnClickOutside: true,
    onShow: () => {
      togglePauseSmoother(true);
    },
    onHide: () => {
      togglePauseSmoother(false);
    },
  });

	function togglePauseSmoother(state) {
		const smoother = window.ScrollSmoother ? ScrollSmoother.get() : null;

		if (smoother) {
			smoother.paused(state);
		}
	}
}
